import type { PageBuilderModuleType } from '~/modules/page-builder/types';
import type { ModulesWithAds, ProjectAd } from '~/modules/adverts/type';

const MAX_PROJECT_ADS = 4;

const getModuleWithAds = (
    modules: PageBuilderModuleType[],
    ads: ProjectAd[]
): ModulesWithAds => {
    let adsIndex = 0;

    // Insert ads into the module array at the calculated indexes
    const modulesWithAds = modules.reduce(
        (list: ModulesWithAds, elem: PageBuilderModuleType, i) => {
            list.push(elem);
            // Insert ads after the first module and every 2 modules after that
            if (i === 0 || (i + 2) % 2 === 0) {
                const ad = ads[adsIndex];
                if (adsIndex <= MAX_PROJECT_ADS && ad) {
                    list.push({
                        presetType: 'ads',
                        ad,
                        id: ad.id,
                    });
                    adsIndex++;
                }
            }
            return list;
        },
        []
    );

    return modulesWithAds;
};

export default getModuleWithAds;
